import { Platform } from 'react-native';

export default function isNativeAnimationSupported() {
  return (
    typeof Platform.constants.reactNativeVersion?.minor === 'number' &&
    Platform.constants.reactNativeVersion.minor <= 72
  );
}
